import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {AlertState} from "@/lib/types/alerting.ts";
import {ServiceDiagnosticData} from "@/lib/types/monitoring.ts";
import {CheckOutput} from "@/pages/checks/rta/components/CheckOutput.tsx";

import "./StatusPerLocationRealtime.css";

type StatusPerLocationRealtimeProps = {
  diagnosticData?: ServiceDiagnosticData;
};

export const StatusPerLocationRealtime = ({diagnosticData}: StatusPerLocationRealtimeProps) => {
  const {user: currentUser} = useCurrentUserContext();

  if (!diagnosticData) return null;

  let output;

  if (diagnosticData.error)
    output = (
      <div className="col">
        <div className="my-2">
          <strong>Live Status:</strong> <span className="text-danger">Failed to query check server.</span>
        </div>
      </div>
    );
  else if (diagnosticData.status === AlertState.NOT_CONFIGURED)
    output = (
      <div className="col">
        <div className="my-2">
          <strong>Live Status:</strong> Awaiting configuration to probe server.
        </div>
      </div>
    );
  else if (diagnosticData.status === AlertState.PENDING)
    output = (
      <div className="col">
        <div className="my-2">
          <strong>Live Status:</strong> Waiting for first check.
        </div>
      </div>
    );
  else
    output = (
      <>
        <div className="col">
          <div className="my-2">
            <strong>Updated:</strong> {shortDateTimeUser(diagnosticData.created_at, currentUser!)}
          </div>
          <div className="my-2">
            <strong>Status:</strong> {diagnosticData.status}
            {diagnosticData.status !== AlertState.OK ? (
              <>
                {" "}
                <span>
                  (retry {diagnosticData.current_attempt - 1} of {diagnosticData.max_attempts - 1}){" "}
                </span>
              </>
            ) : null}
          </div>
          <div className="my-2">
            <strong>Since:</strong> {shortDateTimeUser(diagnosticData.last_state_change, currentUser!)}
          </div>
          <div className="my-2">
            <strong>Last Checked:</strong> {shortDateTimeUser(diagnosticData.last_check, currentUser!)}
          </div>
          <div className="my-2">
            <strong>Next Check:</strong> {shortDateTimeUser(diagnosticData.next_check, currentUser!)}
          </div>
        </div>
        <div className="col-8">
          <div className="my-2">
            <strong>Check Output:</strong>
          </div>
          <div className="my-2">
            <CheckOutput output={diagnosticData.plugin_output} />
          </div>
        </div>
      </>
    );

  return (
    <td colSpan={5}>
      <div className="real-time-check-status card">
        <div className="card-header">
          <strong>Real-Time Check Status</strong>
        </div>
        <div className="card-body p-2 px-3">
          <div className="row">{output}</div>
        </div>
      </div>
    </td>
  );
};
